import React, { useEffect, useState } from 'react';
import { Form } from 'components/ds';
import { CodeItem, ItemInputContainer, ItemWrapper, SendTextData } from './TwoFactorValidationCodeComponent.styles';
import { FooterDiv } from '../../../../components/Css';
import { ResendButton } from '../../pages/validation/styles';

interface TwoFactorValidationCodeProps {
  code: string;
  isResendDisabled: boolean;
  channelValue?: string;
  onCodeChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onResend: () => void;
  onSubmit: () => void;
  setIsResendDisabled: React.Dispatch<boolean>
}

export const TwoFactorValidationCodeComponent = ({
                                                   code,
                                                   isResendDisabled,
                                                   channelValue,
                                                   onCodeChange,
                                                   onResend,
                                                   onSubmit,
                                                   setIsResendDisabled
                                                 }: TwoFactorValidationCodeProps) => {
  
  const defaultTime = 60 * 3
  const [form] = Form.useForm();
  const [seconds, setSeconds] = useState<number>(defaultTime);
  
  const handleInputChange = (index: number, value: string) => {
    if (code.length === 6 && code[index]) {
      return;
    }
    
    const newCode = code.split('');
    newCode[index] = value;
    
    const event = {
      target: {value: newCode.join('')}
    } as React.ChangeEvent<HTMLInputElement>;
    
    onCodeChange(event);
    
    if (value && index < 5) {
      const nextInput = document.querySelector(`input[data-index="${index + 1}"]`);
      (nextInput as HTMLElement)?.focus();
    }
  };
  
  const handleKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Backspace') {
      if (code[index]) {
        const newCode = code.split('');
        newCode[index] = '';
        
        const event = {
          target: {value: newCode.join('')}
        } as React.ChangeEvent<HTMLInputElement>;
        
        onCodeChange(event);
      } else if (index > 0) {
        const prevInput = document.querySelector(`input[data-index="${index - 1}"]`);
        (prevInput as HTMLElement)?.focus();
      }
      
      e.preventDefault();
    }
  };
  
  useEffect(() => {
    if (seconds > 0) {
      const timer = setTimeout(() => setSeconds(seconds - 1), 1000);
      
      return () => clearTimeout(timer);
    }
    
    setIsResendDisabled(false);
  }, [seconds]);
  
  const handleOnResentCode = () => {
    onResend()
    setSeconds(defaultTime)
    setIsResendDisabled(true)
  }
  
  return (
    <>
      
      <SendTextData>
        {
          channelValue ?
          `Digite o código enviado para ${channelValue} para definir sua senha`
          : "Digite o código enviado para definir sua senha"
        }
      </SendTextData>
      
      <ItemWrapper>
        <Form form={form} layout='vertical' onFinish={onSubmit}>
          <ItemInputContainer>
            {[...Array(6)].map((_, index) => (
              <CodeItem
                key={index}
                data-index={index}
                variant="square"
                type="number"
                maxLength={1}
                value={code[index] || ''}
                onChange={(e) => handleInputChange(index, e.target.value.slice(-1))}
                onKeyDown={(e) => handleKeyDown(index, e)}
                autoFocus={index === 0}
              />
            ))}
          </ItemInputContainer>
        </Form>
      </ItemWrapper>
      <FooterDiv>
        <ResendButton type='default' onClick={handleOnResentCode} disabled={isResendDisabled}>
          Reenviar em {seconds > 0
          ? seconds >= 60
            ? `${Math.floor(seconds / 60)}min e ${seconds % 60}s`
            : `${seconds} segundos`
          : 'agora'}
        </ResendButton>
      </FooterDiv>
    </>
  );
};
